import { useEffect } from 'react'

/**
 * Stops the document itself from scrolling for as long as the calling screen is
 * mounted. Needed on the full-viewport landers: clipping the page container is
 * not enough on mobile, where the browser still rubber-bands the document.
 *
 * The lock is applied as a class rather than inline styles so it is scoped to
 * these screens and reverts on unmount, leaving scrollable screens untouched.
 */
export default function useLockBodyScroll() {
  useEffect(() => {
    const { body, documentElement } = document

    body.classList.add('no-scroll')
    documentElement.classList.add('no-scroll')

    return () => {
      body.classList.remove('no-scroll')
      documentElement.classList.remove('no-scroll')
    }
  }, [])
}
